import { constrain } from '@zaibot/mathlib';
import { Motion, spring } from 'react-motion';

import { React } from '../../react';
import Panel, { IPanelProps } from './panel';

import cx from './style.less';

export interface ISlideViewSwitchProps {
    activeIndex: number;
    className?: string;
    /* tslint:disable */
    children?: any | Array<React.ReactElement<IPanelProps>>;
    /* tslint:enable */
}

const panelVisibleThreshold = 0.999;

export default class SlideViewSwitch extends React.Component<ISlideViewSwitchProps, any> {
    private _heights: number[] = [];
    private _renderedHeights: number[] = [];
    private _debounceUpdate: any;

    public render() {
        const { activeIndex, className, children } = this.props;
        const currentHeight = this._heights[activeIndex] || 0;
        const renderedHeight = this._renderedHeights[activeIndex] || 0;
        
        this._renderedHeights[activeIndex] = currentHeight;
        
        return (
            <Motion
                defaultStyle={{ height: 0, viewOffset: activeIndex }}
                style={{ height: renderedHeight ? spring(currentHeight) : currentHeight, viewOffset: spring(activeIndex) }}>
                {({ height, viewOffset }: any) => (
                    <div className={cx('switch', className, { idle: viewOffset === activeIndex, moving: viewOffset !== activeIndex })}>
                        <div className={cx('switch__content')}>
                            {children.qSelect((panel: any, idx: any) => {
                                const localOffset = constrain(viewOffset - idx, -1, 1);
                                return Math.abs(localOffset) >= panelVisibleThreshold
                                    ? null
                                    : (
                                        <Panel
                                            key={idx}
                                            idx={idx}
                                            className={className}
                                            active={idx === activeIndex}
                                            offsetX={localOffset}
                                            onHeightReady={this.setHeight}>
                                            {(panel.props as React.Props<any>).children}
                                        </Panel>
                                    );
                            })}
                        </div>
                    </div>
                )}
            </Motion>
            
        );
        
    }

    public componentWillUnmount() {
        clearTimeout(this._debounceUpdate);
        this._debounceUpdate = null;
    }

    public componentWillReceiveProps(nextProps: ISlideViewSwitchProps) {
        if (this.props.children !== nextProps.children) {
            this.setState({ heights: Array(nextProps.children.length) });
        }
    }

    protected setHeight = (index: number, height: number) => {
        this._heights[index] = height;
        if (!this._debounceUpdate) {
            this._debounceUpdate = setTimeout(() => {
                this._debounceUpdate = null;
                this.forceUpdate();
            });
        }
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/slideView/switch.tsx